import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Email = props => {
  return (
    <SvgIcon {...props} viewBox='0 0 36 36'>
      <path d='M28.4 8H7.6C6.1648 8 5 9.12 5 10.5V25.5C5 26.88 6.1648 28 7.6 28H28.4C29.8352 28 31 26.88 31 25.5V10.5C31 9.12 29.8352 8 28.4 8ZM28.4 13.875L18 20.5425L7.6 13.875V10.8712L18 17.5375L28.4 10.8712V13.875Z' />
    </SvgIcon>
  );
};

export default Email;
